import { defineFcm } from '../shared/factory';

export const FCM_SUPPORTER_TO_STARTER_RECOMMENDATIONS_ENABLED = defineFcm(
	'supporter_to_starter_recommendations_enabled',
)
	.asBoolean()
	.withDefault(false)
	.withMerger(({ localeValue, countryValue }) => localeValue && countryValue)
	.toConfig();
